import { jsx as _jsx } from "react/jsx-runtime";
import CircularProgress from '@mui/material/CircularProgress';
export const LoadingIndicator = ({ color = 'primary', size = undefined, className = '', ...rest }) => (_jsx(CircularProgress, { color: color, size: size, className: className, ...rest }));
//# sourceMappingURL=index.js.map